
export class ProgettoDTO {
  user: string;
  tenant: string; 
  settimanaConsegna: number;
}
